// extracted by mini-css-extract-plugin
export default {"container":"Pagination__container--lYnoB","pagination":"Pagination__pagination--DwgqL","loadMore":"Pagination__loadMore--hFmwS"};